import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatDividerModule } from '@angular/material/divider';

import { AppSharedUIModule } from 'app-shared-ui';
import { BookmarkService } from 'app-service';
import { TranslocoRootModule } from 'app-core';

import { SearchHomeComponent } from './search-home.component';

@NgModule({
  declarations: [
    SearchHomeComponent
  ],
  imports: [
    AppSharedUIModule,
    CommonModule,
    RouterModule.forChild([
      {
        path: '',
        component: SearchHomeComponent,
      },
      {
        path: '**',
        component: SearchHomeComponent,
      },
    ]),
    MatDividerModule,
    TranslocoRootModule,
  ],
  providers: [
    BookmarkService,
  ]
})
export class SearchModule { }
